import styled from "styled-components";

const GameListItem = styled.div`
  display: flex;
  padding: 1.5em;
  background: ${props =>
    props.selected ? "#43275b" : props.active ? "transparent" : "lightgray"};
  cursor: pointer;
  opacity: ${props => (props.active ? 1 : 0.4)};
  @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
    font-size: 1em;
  }

  img {
    max-width: 20%;
    max-height: 6.5em;
    margin-right: 1em;
    margin-left: 1em;

    @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
      max-height: 4.5em;

      margin: 0 0.5em;
    }
  }

  h4 {
    color: ${props => (props.selected ? "#ffffff" : "#683d8c")};
    font-size: 2.5em;
    margin: 0;
    @media (min-width: 1025px) and (max-width: 1440px) {
      font-size: 2.25em;
    }

    @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
      font-size: 1.75em;
    }
  }

  aside {
    color: ${props => (props.selected ? "#ffffff" : "#666666")};
    font-size: 1.5em;

    @media (min-width: 1025px) and (max-width: 1440px) {
      font-size: 1.25em;
    }

    @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
      font-size: 1em;
    }
  }

  &:hover {
    background: #43275b;

    h4 {
      color: #ffffff;
    }

    aside {
      color: #ffffff;
    }
  }
`;

export default GameListItem;
